<template>
    <div>
        <div class="group">
            <!-- <div class="group-title">患者文书</div> -->
            <div class="group-items">
                <div :class="item.children.length > 0 ? `group-item-info`: `group-item`" v-for="item in documentList" :key="item.DocId" @click="handleItem(item)">
                    <span>
                        {{ item.DocName }}
                    </span>
                </div>
            </div>
            <div class="empty" v-if="!documentList.length">暂无数据</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { mapGetters } from 'vuex'
export default {
    name: `DoucmentList`,
    props: {
        surgeryId: Number,
        surgeryInfo: Object,
        visible: { type: Boolean }
    },
    components: {},
    data() {
        return {
            DicDocManagementList: null,
            DocumentConfig: null,
            activeDoc: undefined,
            documentList: [], // 文书明细
            catoken: sessionStorage.getItem(`caToken`)
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`currentUser`])
    },
    mounted() {
        let that = this
        console.log(that.surgeryInfo)
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            if (that.surgeryInfo) {
                that.loadDicDocManagementList(that.surgeryInfo)
            }
        })
    },
    methods: {
        handleItem(item) {
            // const [doc] = item.children
            // if (!doc) {
            //     // 没有文书实例 创建文书
            // } else {
            //     // sessionStorage.setItem(`activeDoc`, JSON.stringify(item))
            // }
            sessionStorage.setItem(`activeDoc`, JSON.stringify(item))
            this.$router.push({ name: `DoucmentInfo`, query: { surgeryId: this.surgeryId } }).catch(err => err)
        },
        loadDicDocManagementList(surgery) {
            let that = this
            console.log(11111)
            if (surgery && surgery.id > 0) {
                let vid = surgery.id
                return new Promise((resolve, reject) => {
                    let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                        headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                        params: { deptno: `acis2020`, permission: `0-11111111111`, vid: vid }
                    })
                    req.then(dicDocManagementList => {
                        that.DicDocManagementList = dicDocManagementList
                        resolve(that.DicDocManagementList)
                    }).then(d => {
                        that.loadDocumentConfig().then(d => {
                            this.loadDocumentLists(surgery)
                        })
                    })
                })
            }
        },
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.DocumentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocumentLists(surgery) {
            let that = this
            return new Promise((resolve, reject) => {
                let surgeryid = surgery.id
                let r = _.filter(_.orderBy(that.DicDocManagementList.data, `PrintOrder`), d => {
                    let dc = _.find(that.DocumentConfig, d3 => d3.document_id == d.DocNo && d3.is_deleted == false &&
                        (d3.enum_worker_role == null ||
                            d3.enum_worker_role == 0 ||
                            d3.enum_worker_role == (that.currentUser.worker_role == `医生` ? 1 : 2))
                    )
                    return (
                        dc && _.some(dc.regions, reg => {
                            return (reg.dic_operating_ward_id == surgery.dic_operating_ward_id && surgery.dic_operating_ward_id) || (reg.dic_recovery_ward_id == surgery.dic_recovery_ward_id && surgery.dic_recovery_ward_id)
                        })
                    )
                }).map(dr => {
                    let d = { ...dr }
                    let ddddd = _.find(that.DocumentConfig, d3 => d3.document_id == d.DocNo)
                    console.log(`dr`, dr)
                    d.issingleton = ddddd && ddddd.is_singleton // 是否单例
                    d.surgeryId = surgeryid
                    d.surgery = surgery
                    d.index = `${d.DocNo}`
                    d.hasChildren = d.IsSurportHtml // 可编辑文书
                    d.children = []
                    d.label = d.DocName
                    return d
                }) || []
                resolve(r)
            }).then(documentList => {
                that.documentList = documentList
                console.log(222)
                console.log(documentList)
                this.loadInstances(documentList)
            })
        },
        loadInstances(documentList) {
            let that = this
            return new Promise((resolve, reject) => {
                if (documentList && documentList.length > 0) {
                    let items = []
                    let surgerydocumentList = documentList.filter(d => d.hasChildren && d.DocNo > 0)
                    _.map(surgerydocumentList, d => {
                        items.push({
                            docid: d.index,
                            issingleton: d.issingleton,
                            vid: d.surgeryId
                        })
                    })
                    let objs = {
                        dept: `acis2020`,
                        items: items
                    }
                    // 调用文书获取结果
                    let url = `${that.$root.DOCSERVICE_BASE}/Wth/QueryWTHMainData`
                    axios
                        .post(
                            url,
                            Qs.stringify(objs),
                            Object.assign({
                                emulateJSON: true
                            })
                        )
                        .then(res => {
                            if (res.Status == `SUCCESS`) {
                                let contents = res.Content
                                contents = _.filter(contents, f => {
                                    return f.istemplate == `0`
                                }).map(f => {
                                    f.index = `${f.docbizid}`
                                    f.docno = f.docno
                                    f.label = f.docname
                                    return f
                                })

                                let surgerydoc = _.filter(contents, item => item.vid == that.surgeryId)

                                _.map(documentList, document => {
                                    let r = _.filter(surgerydoc, s => s.docno == document.DocNo)
                                    if (r) {
                                        that.$set(document, `children`, r)
                                    }
                                })
                                that.documentList = documentList
                            }
                            console.log(`documentList`)
                            console.log(that.documentList)
                            resolve(that.documentList)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                }
            })
        }
    },
    beforeDestroy() {
    },
    watch: {
        visible: function(newUrl, oldUrl) {
            if (this.visible) {
                if (this.surgeryInfo) {
                    this.loadDicDocManagementList(this.surgeryInfo)
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.group {
    padding: 16px;
    .group-title {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
        text-align: left;
        margin-bottom: 12px;
    }
    .group-items {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .group-item-info {
            padding: 6px 8px;
            color: #04b9a8;
            font-size: 14px;
            border-radius: 4px;
            background-color: rgb(#04b9a8, 0.1);
        }
        .group-item {
            padding: 6px 8px;
            color: #6d6c71;
            font-size: 14px;
            border-radius: 4px;
            background-color: rgb(#6d6c71, 0.1);
        }
    }
    .empty {
        font-size: 14px;
        color: #ddd;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/DoucmentList.vue